import React, { useState } from 'react';
import { Input, Select, Space, DatePicker } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { ArrowDownTrayIcon } from '@heroicons/react/20/solid';
import { Button } from '@clockout-dev/design-elements';
import { exportLedgerToCSV } from '../../../utils/exportUtils';

const { RangePicker } = DatePicker;
const { Option } = Select;

const LedgerTableActions = ({ ledger, setRows, rows, canAction = true }) => {
    const [searchText, setSearchText] = useState('');
    const [dateRange, setDateRange] = useState(null);
    const [type, setType] = useState('all');

    const handleSearch = (value) => {
        setSearchText(value);
        filterData(value, dateRange, type);
    };

    const handleDateRange = (dates) => {
        setDateRange(dates);
        filterData(searchText, dates, type);
    };

    const handleTypeChange = (value) => {
        setType(value);
        filterData(searchText, dateRange, value);
    };

    const handleDownloadExcel = () => {
        exportLedgerToCSV(rows || ledger);
    };

    const filterData = (search, dates, selectedType) => {
        let filteredData = [...ledger];

        if (search) {
            filteredData = filteredData.filter((item) => {
                const searchLower = search.toLowerCase();
                return (
                    item.account_number.toLowerCase().includes(searchLower) ||
                    item.pay_period.toLowerCase().includes(searchLower) ||
                    item.client_id.toLowerCase().includes(searchLower)
                );
            });
        }

        if (dates) {
            filteredData = filteredData.filter((item) => {
                const itemDate = new Date(item.created_at);
                return itemDate >= dates[0].startOf('day') && itemDate <= dates[1].endOf('day');
            });
        }

        if (selectedType !== 'all') {
            filteredData = filteredData.filter((item) => item.type === selectedType);
        }

        setRows(filteredData);
    };

    return (
        <div style={{ marginBottom: 16 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                <span style={{ fontSize: 16, fontWeight: 600 }}>Filters</span>
                {canAction && (
                    <Button icon={<ArrowDownTrayIcon />} onClick={handleDownloadExcel}>
                        Download Excel
                    </Button>
                )}
            </div>
            <Space style={{ marginBottom: 16 }} wrap>
                <Input
                    placeholder="Search by account number, pay period, or client ID"
                    onChange={(e) => handleSearch(e.target.value)}
                    prefix={<SearchOutlined />}
                    style={{ width: 300 }}
                />
                <RangePicker onChange={handleDateRange} />
                <Select defaultValue="all" style={{ width: 120 }} onChange={handleTypeChange}>
                    <Option value="all">All Types</Option>
                    <Option value="advance">Advance</Option>
                    <Option value="service_fee">Service Fee</Option>
                </Select>
            </Space>
        </div>
    );
};

export default LedgerTableActions;
